import React from 'react';
import { Helmet, HelmetProvider } from 'react-helmet-async';
import Header from '../components/Header';
import Footer from '../components/Footer';
import { siteMetadata } from '../lib/seo';

const MainLayout = ({ children, title, description, keywords, structuredData }) => {
  const pageTitle = title
    ? `${title} | ${siteMetadata.companyName}`
    : siteMetadata.title;

  const pageDescription = description || siteMetadata.description;
  const pageKeywords = keywords || siteMetadata.keywords.join(', ');

  return (
    <HelmetProvider>
      <div className="min-h-screen flex flex-col bg-white">
        <Helmet>
          <title>{pageTitle}</title>
          <meta name="description" content={pageDescription} />
          <meta name="keywords" content={pageKeywords} />
          <meta name="author" content={siteMetadata.author} />

          {/* Open Graph */}
          <meta property="og:title" content={pageTitle} />
          <meta property="og:description" content={pageDescription} />
          <meta property="og:type" content="website" />
          <meta property="og:url" content={siteMetadata.siteUrl} />
          <meta property="og:site_name" content={siteMetadata.companyName} />

          {/* Twitter Card */}
          <meta name="twitter:card" content="summary_large_image" />
          <meta name="twitter:title" content={pageTitle} />
          <meta name="twitter:description" content={pageDescription} />

          {/* Structured Data */}
          {structuredData && (
            <script type="application/ld+json">
              {JSON.stringify(structuredData)}
            </script>
          )}
        </Helmet>

        <Header />

        <main className="flex-grow pt-20">
          {children}
        </main>

        <Footer />
      </div>
    </HelmetProvider>
  );
};

export default MainLayout;
